import { render, staticRenderFns } from "./PlatformReceiptsPaymentsStatements.vue?vue&type=template&id=1f2f3e56&scoped=true"
import script from "./PlatformReceiptsPaymentsStatements.vue?vue&type=script&lang=js"
export * from "./PlatformReceiptsPaymentsStatements.vue?vue&type=script&lang=js"
import style0 from "./PlatformReceiptsPaymentsStatements.vue?vue&type=style&index=0&id=1f2f3e56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f3e56",
  null
  
)

export default component.exports